import {
  Image,
  useCurrentOrderQuery,
  useCurrentUserQuery,
  useListingQuery,
} from '@/api'
import { useParams, useRouter } from 'next/navigation'
import { useMemo } from 'react'

export const useListingData = () => {
  const router = useRouter()
  const params = useParams()

  // Data fetching
  const {
    data: { listing } = {},
    loading,
    refetch,
  } = useListingQuery({
    variables: {
      uuid: params.id?.toString() || '',
    },
    fetchPolicy: 'cache-and-network',
    skip: !params.id,
    onCompleted: (data) => {
      if (data.listing?.isSoldOut) {
        const productName = data.listing?.product?.productMaster?.name
        if (productName) {
          setTimeout(() => {
            router.push(
              `/listings?page=1&keyword=${encodeURIComponent(productName)}`
            )
          }, 1000)
        }
      }
    },
  })

  const { data: { currentOrder } = {} } = useCurrentOrderQuery({
    variables: {
      brandUuid: process.env.NEXT_PUBLIC_BRAND_ID_CANADAGOOSE ?? '',
    },
    skip: !process.env.NEXT_PUBLIC_BRAND_ID_CANADAGOOSE,
    fetchPolicy: 'cache-and-network',
  })

  const { data: { currentUser } = {} } = useCurrentUserQuery({
    fetchPolicy: 'cache-and-network',
  })

  // Computed properties
  const isSoldOut = listing?.isSoldOut
  const recentListings = currentUser?.recentViewedListings ?? []
  const isAuthenticated = Boolean(currentUser?.id)
  const productImages = listing?.product?.images || []
  const listingImages = listing?.images || []
  const conditionTextList = listing?.conditionText
    ? listing.conditionText.split('\n')
    : []
  const sizeGuides = listing?.product?.productMaster?.sizeGuides ?? null

  const isLiked = useMemo(() => {
    return listing?.isLiked
  }, [listing?.isLiked])

  return {
    // Data
    listing,
    currentOrder,
    currentUser,
    productImages: productImages as Image[],
    listingImages: listingImages as Image[],
    recentListings,
    conditionTextList,
    sizeGuides,

    // Computed states
    isSoldOut,
    isAuthenticated,
    isLiked,
    loading,

    // Refetch function
    refetch,
  }
}
